import React from "react";

class RecommendationsList extends React.Component {

    openFullSize(image) {
        switch (image) {
            case "Test":
                window.open("./recommendations/test.jpg", "_blank");
                break;
            default:
                break;
        }
    }

    render() {
        switch (this.props.recommendations) {
            case "en":
                this.selectedRecommendation = <div>
                    <div className="recommendations-wrapper">
                        <img className="recommendations-img" onClick={() => this.openFullSize('Test')} src="./recommendations/thumb/test.jpg" alt="Recommendation"></img>
                    </div>
                </div >

                break;

            case "bg":
                this.selectedRecommendation = <div>
                    <div className="recommendations-wrapper">
                        <img className="recommendations-img" onClick={() => this.openFullSize('Test')} src="./recommendations/thumb/test.jpg" alt="Recommendation"></img>
                    </div>
                </div >

                break;

            default:
                break;
        }
        return this.selectedRecommendation;
    }
}

export default RecommendationsList;